import styled from 'styled-components';

import Mobile from './Mobile';

const StyledMobile = styled(Mobile)`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 12px;
    
    justify-content: flex-start;
    align-items: center;
    
    & > *:first-child {
        width: 72px;
        height: 48px;
        flex: 0 0 auto;
        align-self: flex-start;
    }
`;

export default StyledMobile;
